import { Button, Col, Form, Input, Modal, Row } from "antd";
import { Bundle } from "../../../model/root/Bundle";
import { useState } from "react";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import { PostBundles } from "../../../dao/root/PostBundles";

interface IngredientModalProps {
    element: Bundle;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: () => void;
}

const BundlesModal: React.FC<IngredientModalProps> = ({element, visible, editar, page, onClose}) => {
    const [form] = Form.useForm();

    async function handleSubmit() {
        const id = await form.getFieldValue('id');
        const nom = await form.getFieldValue('nom');
        const valor = await form.getFieldValue('valor');
        const env = await form.getFieldValue('env');
        await PostBundles(id, nom, valor, env, page);
        await onClose();
    }

    const filterOption = (input: string, options?: { label: string; value: string }) =>
        (options?.label ?? '').toLowerCase().includes(input.toLowerCase());

    async function handleCancel() {

        await onClose();
    };
    if (!editar) {
        return(
            <Modal
            title="Mostrar Bundle"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={600}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={42}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom">
                                <Input type="text" disabled/>
                        </Form.Item>
                        <Form.Item label="Valor" name="valor">
                                <Input type="text" disabled/>
                        </Form.Item>
                        <Form.Item label="Entorn" name="env">
                                <Input type="text" disabled/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>

        )
    }
    return(
        <Modal
            title="Crear/Editar Bundle"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={600}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={42}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                            rules={[{ required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Valor" name="valor"
                            rules={[{ required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Entorn" name="env"
                            rules={[{ required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input type="text"/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>

    )
};

export default BundlesModal;